import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/index.css';

// Aggressively unregister any existing service workers
if ('serviceWorker' in navigator) {
  // Unregister all existing service workers
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const registration of registrations) {
      registration.unregister().then((success) => {
        if (success) {
          console.log('Service worker unregistered');
        }
      });
    }
  });
  
  // Also try to unregister by scope
  navigator.serviceWorker.getRegistration().then((registration) => {
    if (registration) {
      registration.unregister();
    }
  });
  
  // Prevent new registrations by overriding register
  navigator.serviceWorker.register = function() {
    console.warn('Service worker registration blocked');
    return Promise.reject(new Error('Service workers are disabled'));
  };
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

